import React from 'react';
import Heading from '../../../Typography/Heading/Heading.mjs';
import StyledLink from '../../Link/Link.mjs';
import { StyledWrapper, StyledContainer, StyledList, StyledListItem } from './Horizontal.styles.mjs';

const ListElement = ({ name }) => (React.createElement(Heading, { tag: "h6", uppercase: true }, name));
const HorizontalList = ({ options, onClick, className, testId, wrap }) => {
    return (React.createElement(StyledWrapper, { className: className, "data-testid": testId },
        React.createElement(StyledContainer, null,
            React.createElement(StyledList, { wrap: wrap }, options === null || options === void 0 ? void 0 : options.map((option, index) => (React.createElement(StyledListItem, { value: option.name, key: index, onClick: () => onClick(option) }, option.href ? (React.createElement(StyledLink, { href: option.href },
                React.createElement(ListElement, { name: option.name }))) : (React.createElement(ListElement, { name: option.name })))))))));
};

export { HorizontalList as default };
//# sourceMappingURL=HorizontalList.mjs.map
